import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

interface UseGetGlMasterProps {
  communityId: string;
  year: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGlMasterDataByBudgetYear = async (communityId: string, year: string) =>
  await axiosAuth.get(
    `${GET_GL_MASTER_DATA}/community/${communityId}/budget-year/${year}`
  );

const useGetGlMasterDataByBudgetYear = ({
  communityId,
  year,
  queryParams,
}: UseGetGlMasterProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-master-data-by-budget", communityId, year],
    queryFn: () => getGlMasterDataByBudgetYear(communityId, year),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId,
    ...queryParams,
  });
};

export default useGetGlMasterDataByBudgetYear;
